import { createReducer } from 'typesafe-actions';
import produce from 'immer';

import * as Actions from '../actions/basisDronAction';
import { DronState, initDron } from '../models/basisDronModel';

export const dronReducer = createReducer<DronState, Actions.DronAction>(
  initDron
)
  .handleAction(Actions.LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count, total } = action.payload;
      draft.list = data;
      draft.count = count;
      draft.total = total;
    })
  )
  .handleAction(Actions.IDNTF_LIST.success, (state, action) =>
    produce(state, draft => {
      const { data, count } = action.payload;
      draft.listIdntf = data;
      draft.isRefreshIdntf = false;
      draft.idntfCount = count;
    })
  )
  .handleAction(Actions.SELECT, (state, action) =>
    produce(state, draft => {
      const selectData = action.payload;
      draft.selectData = selectData;
    })
  )
  .handleAction(Actions.IDNTF_CREATE.success, (state, action) =>
    produce(state, draft => {
      draft.isRefreshIdntf = true;
    })
  )
  .handleAction(Actions.IDNTF_DELETE.success, (state, action) =>
    produce(state, draft => {
      draft.isRefreshIdntf = true;
    })
  )
  .handleAction(Actions.RESET_IDNTF, (state, action) =>
    produce(state, draft => {
      draft.detail = undefined;
      draft.listIdntf = undefined;
      draft.isRefreshIdntf = false;
      draft.idntfCount = 0;
    })
  )

  .handleAction(Actions.DETAIL.success, (state, action) =>
    produce(state, draft => {
      const data = action.payload;
      draft.detail = data;
    })
  );
